var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutPopupIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.983,
    height: 70,
    viewBox: "0 0 69.983 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9097",
    d: "M41.068 37.922a8.749 8.749 0 0 1 0-17.5H46.9V8.754A8.759 8.759 0 0 0 38.151 0H6.8a2.914 2.914 0 0 0-2.721 3.954l21.142 55.414a2.91 2.91 0 0 0 2.723 1.878H38.15A8.759 8.759 0 0 0 46.9 52.5V37.922z",
    transform: "translate(-.242)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9098",
    d: "M52.089 42.488a2.927 2.927 0 0 1-1.8-2.7v-8.744H38.626a2.917 2.917 0 1 1 0-5.832H50.29v-8.749a2.915 2.915 0 0 1 4.978-2.063l11.665 11.666a2.913 2.913 0 0 1 0 4.123L55.268 41.854a2.917 2.917 0 0 1-3.179.634z",
    transform: "translate(2.195 1.039)",
    style: {
      fill: "#6acaf4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9099",
    d: "M25.716 6.135 8.192.293A5.873 5.873 0 0 0 .5 5.837v52.5a5.862 5.862 0 0 0 3.947 5.533l17.52 5.841a6.17 6.17 0 0 0 1.86.289 5.838 5.838 0 0 0 5.832-5.832v-52.5a5.864 5.864 0 0 0-3.945-5.536z",
    transform: "translate(-.502)",
    style: {
      fill: "#e7f6ff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutPopupIcon);
export default __webpack_public_path__ + "static/media/logout-popup-icon.ebbe8e4b17a5ef3ee18a459ff8459e7d.svg";
export { ForwardRef as ReactComponent };